import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';
import { uiHelper } from '../../../helpers/ui.helper';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_livebets_keyboard_search_modal',
    templateUrl: './livebets_keyboard_search_modal.html',
})
export class LiveBetsKeyboardSearchModal implements OnInit {
    public KeyboardSearch_Input_Value = '';

    public init: boolean;
    constructor(public tournamentsService: TournamentsService, private _uiHelper: uiHelper) {}
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }

    public KeyboardSearch_ChangeValue(e) {
        this.KeyboardSearch_Input_Value += e;
        this.tournamentsService.TerminalSearchValue += e;
        if (this.tournamentsService.TerminalSearchValue.length > 2) this.tournamentsService.getSportFixture_Search();
        // this.tournamentsService.GetFixtureSearch();
    }

    public KeyboardSearch_Backspace() {
        this.KeyboardSearch_Input_Value = this.KeyboardSearch_Input_Value.slice(0, -1);
        // this.tournamentsService.UserNameValue = this.tournamentsService.UserNameValue.slice(0, -1);
        // this.tournamentsService.UserPasswordValue = this.tournamentsService.UserPasswordValue.slice(0, -1);
        this.tournamentsService.TerminalSearchValue = this.tournamentsService.TerminalSearchValue.slice(0, -1);
        this.tournamentsService.getSportFixture_Search();
        if (this.KeyboardSearch_Input_Value == '') {
            this.tournamentsService.getSportFixture('');
            this._uiHelper.changeSportFixture.emit(true);
        }
        // this.tournamentsService.GetFixtureSearch();
    }

    public KeyboardSearch_Close() {
        this.KeyboardSearch_Input_Value = '';
        this.tournamentsService.UserNameValue = '';
        this.tournamentsService.UserPasswordValue = '';
        this.tournamentsService.getSportFixture_Search();
        // this.tournamentsService.TerminalSearchValue = "";
        $('#LiveBets_Keyboard_Search_Modal').modal('hide');
    }
    public KeyboardSearch_Input_Clear() {
        // console.log("CLEAR");
        // this.tournamentsService.UserNameValue = "";
        // this.tournamentsService.UserPasswordValue = "";
        this.KeyboardSearch_Input_Value = '';
        this.tournamentsService.TerminalSearchValue = '';
        this.tournamentsService.getSportFixture('');
        this._uiHelper.changeSportFixture.emit(true);
        // this.tournamentsService.GetFixtureSearch();
    }
}
